/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var radio = require('ES/lib/radio');
var _ = require('ES/lib/lodash');

var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var HoverMixin = require('ES/utils/HoverMixin');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var FormUtils = require('../../../../../utils/FormUtils');

module.exports = dd.createClass({
	__onSubmit: function(data){
		var event = _.cloneDeep(this.props.event);
		var hotel = this.props.data;
		var onCancel = this.props.onCancel;

		if(!_.isArray(event.Hotel)){
			event.Hotel = [];
		}
		if(!hotel || hotel.id < 1){
			hotel = {id: 0, eid: event.eid};
			event.Hotel.push(hotel);
		}
		_.each(event.Hotel, function(h){
			if(h.id == hotel.id){
				h.checkindate = data.checkindate;
				h.checkoutdate = data.checkoutdate;
				h.name = data.name;
				h.confirmation = data.confirmation;
				h.phone = data.phone;
				h.fax = data.fax;
				h.address = data.address;
				h.city = data.city;
				h.st = data.st;
				h.country = data.country;
				h.zip = data.zip;
			}
		});
		radio('save_Event').broadcast(event);
		if(_.isFunction(onCancel)){
			onCancel();
		}
	},
	__onDelete: esUtils.wrapPreventDefault(function(){
		var event = _.cloneDeep(this.props.event);
		var hotel = this.props.data;
		var onCancel = this.props.onCancel;

		if(hotel && hotel.id > 0){
			event.Hotel = _.reject(event.Hotel, function(h){
				return hotel.id == h.id;
			});
			radio('save_Event').broadcast(event);
		}
		if(_.isFunction(onCancel)){
			onCancel();
		}
	}),
	render: function(){
		return DaForm(_.assign({onSubmit: this.__onSubmit, onDelete: this.__onDelete}, this.props));
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValues: function(props){
		var hotel = props.data;
		var event = props.event || {};
		var stagetime = (_.isEmpty(event.Stagetime)) ? null : _.first(event.Stagetime);
		var venue = (_.isEmpty(stagetime)) ? null : _.first(_.first(event.Venue, {id: stagetime.venueid}));

		if(hotel && hotel.id > 0){
			return {
				checkindate: hotel.checkindate,
				checkoutdate: hotel.checkoutdate,
				name: hotel.name,
				confirmation: hotel.confirmation,
				phone: hotel.phone,
				fax: hotel.fax,
				address: hotel.address,
				city: hotel.city,
				st: hotel.st,
				country: hotel.country,
				zip: hotel.zip
			};
		}else if(!_.isEmpty(stagetime) && !_.isEmpty(venue)){
			//fill in some default data based on stagetime
			var checkin = new Date(stagetime.starttime);
			var checkout = new Date(stagetime.stoptime);
			checkin.setDate(checkin.getDate() - 1);
			checkout.setDate(checkout.getDate() + 1);
			return {
				checkindate: checkin,
				checkoutdate: checkout,
				name: '',
				confirmation: '',
				phone: '',
				fax: '',
				address: '',
				city: venue.city,
				st: venue.st,
				country: venue.country,
				zip: venue.zip
			};
		}
		return null;
	},
	buildFields: function(){
		var data = this.state.data || {};
		return _.assign(FormUtils.buildAddressFields(this.props.Displaylists, data), {
			checkindate: {
				label: 'Check in',
				type: 'date',
				pick_time: false
			},
			checkoutdate: {
				label: 'Check out',
				type: 'date',
				pick_time: false,
				validate: FormUtils.optional
			},
			name: {
				label: 'Hotel',
				type: 'text',
				placeholder: 'Marriott Downtown',
				validate: FormUtils.required
			},
			confirmation: {
				label: 'Conf #',
				type: 'text',
				placeholder: '123ABC',
				validate: FormUtils.optional
			},
			phone: {
				label: 'Phone',
				type: 'text',
				validate: FormUtils.optional
			},
			fax: {
				label: 'Fax',
				type: 'text',
				validate: FormUtils.optional
			}
		});
	},
	__copyFromVenue: function(venue){
		_.each(['address', 'city', 'st', 'zip', 'country', 'phone', 'fax'], function(f){
			this._form_onChange(f, venue[f]);
		}, this);
		this._form_onChange('name', venue.building);
	},
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var _form_buildInput = this._form_buildInput;

		var hotel = this.props.data;
		var event = this.props.event || {};
		var onCancel = this.props.onCancel;
		var onDelete = this.props.onDelete;

		var makeFields = function(layout){
			return HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: _form_buildInput,
				label_size: 2,
				layout: layout
			});
		};


		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			makeFields([
				['name'],
				['checkindate', 'checkoutdate'],
				['confirmation'],
				['phone', 'fax']
			]),
			_.isEmpty(event.Venue) ? null : dd.div({className: "HorizontalFields"},
				dd.div({className: "form-group"},
					dd.div({className: "col-sm-12"},
						CopyFromVenueDropDown({venues: event.Venue, copyFromVenue: this.__copyFromVenue})
					)
				)
			),
			makeFields([
				['address'],
				['city', 'st'],
				['zip', 'country']
			]),
			HorizontalFields.FormButtons({
				label_size: 2,
				scale: 'md',
				submit_btn_text: hotel && hotel.id > 0 ? 'Save' : 'Add',
				onCancel: onCancel,
				onDelete: hotel && hotel.id > 0 ? onDelete : null,
				right_align_buttons: true
			})
		);
	}
});

var CopyFromVenueDropDown = dd.createClass({
	mixins: [HoverMixin],
	getInitialState: function(){
		return {show_dd: false};
	},
	__toggleDropDown: esUtils.wrapPreventDefault(function(){
		this.setState({show_dd: !this.state.show_dd});
	}),
	hoverable_onUserLeftHoverable: function(){
		if(this.state.show_dd){//only setState if needed
			this.setState({show_dd: false});
		}
	},
	__venueClick: function(venue){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			self.setState({show_dd: !self.state.show_dd});
			self.props.copyFromVenue(venue);
		});
	},
	render: function(){
		return dd.div({
				className: "pull-right dropdown" + (this.state.show_dd ? " open" : ""),
				onMouseEnter: this.hoverable_onMouseEnter,
				onMouseLeave: this.hoverable_onMouseLeave
			},
			dd.a({href: '#', className: 'dropdown-toggle', onClick: this.__toggleDropDown},
				"copy address from venue ", dd.b({className: 'caret'})
			),
			dd.ul({className: 'dropdown-menu', role: 'menu'},
				_.map(this.props.venues, function(venue){
					return dd.li({key: venue.id, role: 'presentation'},
						dd.a({role: 'menuitem', href: '#', onClick: this.__venueClick(venue)}, esUtils.venue_to_string(venue))
					);
				}, this)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/HotelForm.js